export const getFiscalYearRange = (date) => {
  const selectedDate = date ? new Date(date) : new Date();
  const year = selectedDate.getFullYear();
  let minDate, maxDate;
  if (selectedDate.getMonth() >= 6) { // 0-indexed: 6 is July
    minDate = new Date(year, 6, 1); // July 1st of current year
    maxDate = new Date(year + 1, 5, 30); // June 30th of next year
  } else {
    minDate = new Date(year - 1, 6, 1); // July 1st of previous year
    maxDate = new Date(year, 5, 30); // June 30th of current year
  }
  const today = new Date();
  if (maxDate > today) {
    maxDate = today;
  }
  return { minDate, maxDate };
};

export const isPreviousFiscalYear = (date) => {
  if (!date) return false;
  const txRange = getFiscalYearRange(date);
  const today = new Date();
  return today < txRange.minDate || today > txRange.maxDate;
};

export const getMinMaxDates = (selectedDate, initialDate) => {
  const activeDate = selectedDate || initialDate || new Date();
  return getFiscalYearRange(activeDate);
};

export const validateTransactionDate = (selectedDate, initialDate) => {
  return null;
};
